import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({ providedIn: 'root' })
export class CurrencyService {
  private readonly STORAGE_KEY = 'selectedCurrency';
  private isBrowser: boolean;
  private selectedCurrency: BehaviorSubject<string>;
  private exchangeRates: { [key: string]: number } = environment.exchangeRates;
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    const savedCurrency = this.isBrowser
      ? localStorage.getItem(this.STORAGE_KEY)
      : null;
    this.selectedCurrency = new BehaviorSubject<string>(
      savedCurrency || environment.baseCurrency
    );
  }
  setCurrency(curr: string) {
    if (this.isBrowser) {
      localStorage.setItem(this.STORAGE_KEY, curr);
    }
    this.selectedCurrency.next(curr);
  }
  getCurrency() {
    return this.selectedCurrency.asObservable();
  }
  getCurrentCurrency(): string {
    return this.selectedCurrency.getValue();
  }
  getRate(currency: string): number {
    return this.exchangeRates[currency] || 1;
  }
  convertFromAED(value: number): number {
    const rate = this.getRate(this.getCurrentCurrency());
    return value * rate;
  }
}